import {
  useAddClientGroup,
  useEditClientGroup,
} from "features/ClientGroups/api";
import { useSetAtom } from "jotai";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";
import { UseFormHandleSubmit } from "react-hook-form";

import { Button, ButtonProps, EButtonVariant } from "components/Button/Button";

import { ClientGroupForm } from "../ClientGroupInfo";

type Props = ButtonProps & {
  isEdit: boolean;
  handleSubmit: UseFormHandleSubmit<ClientGroupForm>;
  canBeSaved: boolean;
};

export function Footer({ isEdit, handleSubmit, canBeSaved }: Props) {
  const closeModal = useSetAtom(setModalCloseAtom);
  const { mutate: addClientGroup } = useAddClientGroup();
  const { mutate: editClientGroup } = useEditClientGroup();

  const handleClick = (data: ClientGroupForm) => {
    const { clientgroupid, avaliable, ...rest } = data;

    if (isEdit) {
      editClientGroup({ ...rest, avaliable: avaliable ? 1 : 0, clientgroupid });
    } else {
      addClientGroup({ avaliable: avaliable ? 1 : 0, ...rest });
    }

    closeModal();
  };

  return (
    <Button
      variant={EButtonVariant.SECONDARY}
      onClick={handleSubmit(handleClick)}
      icon="galochka"
      disabled={!canBeSaved}
    >
      Сохранить
    </Button>
  );
}
